import React from 'react';
import { connect } from 'dva';
import { injectIntl } from 'react-intl';
import MeetingReport from '../components/report/MeetingReport';

export default connect(state => ({ ...state, loading: state.loading.global }))(
  injectIntl(({ meetingReport, loading, intl, dispatch }) => {
    return (
      <div className="container-left">
        <MeetingReport
          intl={intl}
          dispatch={dispatch}
          meetingReport={meetingReport}
          loading={loading}
        />
      </div>
    );
  })
);



// WEBPACK FOOTER //
// ./src/routes/MeetingReport.js